import { toValue } from 'vue'

import type { UseVariantsQueryOptions } from '@/domains/products/composables/use-variants-query/useVariantsQuery.types'

import { callVariants } from '@/domains/variants/services'
import { STALE_TIMES } from '@/support/query/constants'
import { useSearchableQuery } from '@/support/query/useSearchableQuery'

export const VARIANTS_QUERY_KEY = ['variants'] as const

const DEFAULT_INCLUDE = 'media,product.media'

export const useVariantsQuery = (options: UseVariantsQueryOptions = {}) =>
  useSearchableQuery(
    // `include` rides in the params so two includes never share a cache entry.
    { ...options, params: () => ({ include: options.include ?? DEFAULT_INCLUDE, ...toValue(options.params) }) },
    {
      queryKey: VARIANTS_QUERY_KEY,
      fetchItems: async ({ search, params }) => {
        const response = await callVariants().index({ queryParams: { q: search, ...params } })
        return response.data.value?.data ?? []
      },
      staleTime: STALE_TIMES.HIGH_CHURN,
      minSearchLength: options.minSearchLength
    }
  )
